import { Entity } from '../types/Voucher';

const EntityLabelMap: Record<Entity, string> = {
  flix_inc: 'Flix Inc',
  flix_mexico: 'Flix Mexico',
  kamil_koc: 'Kamil Koc',
  flix_brazil: 'Flix Brazil',
  flix_chile: 'Flix Chile',
  flix_india: 'Flix India',
  flix_se: 'Flix SE',
};

export const getEntityLabel = (entity: Entity | null | undefined): string => {
  if (!entity) return '—';
  return EntityLabelMap[entity] ?? entity;
};
